"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEquipmentSlotName = void 0;
const retrommo_types_1 = require("retrommo-types");
const getEquipmentSlotName = (equipmentSlot) => {
    switch (equipmentSlot) {
        case retrommo_types_1.EquipmentSlot.Body:
            return "Body";
        case retrommo_types_1.EquipmentSlot.Head:
            return "Head";
        case retrommo_types_1.EquipmentSlot.MainHand:
            return "Main Hand";
        case retrommo_types_1.EquipmentSlot.OffHand:
            return "Off Hand";
    }
};
exports.getEquipmentSlotName = getEquipmentSlotName;
